<template>
  <v-app>
    <!-- Header -->
    <v-app-bar app color="white" elevate-on-scroll flat>
      <v-container class="mx-0 mobile-container">
        <v-row align="center" justify="space-between" no-gutters>
          <v-col cols="2" class="logo-col">
            <router-link to="/" class="logo-link">
              <v-img
                  :src="logoUrl"
                  alt="Multicare Rewards"
                  contain
                  height="50"
                  class="logo-image"
              />
            </router-link>
          </v-col>
          <v-col cols="auto">
            <v-menu
                offset-y
                bottom
                left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item to="/">
                  <v-list-item-title>Home</v-list-item-title>
                </v-list-item>
                <v-list-item to="/vote">
                  <v-list-item-title>Vote</v-list-item-title>
                </v-list-item>
                <v-list-item to="/results">
                  <v-list-item-title>Results</v-list-item-title>
                </v-list-item>
<!--                <v-list-item to="/login">-->
<!--                  <v-list-item-title>Login</v-list-item-title>-->
<!--                </v-list-item>-->
<!--                <v-list-item to="/register">-->
<!--                  <v-list-item-title>Register</v-list-item-title>-->
<!--                </v-list-item>-->
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <!-- Main content -->
    <v-main class="pt-8">
      <router-view />
    </v-main>

    <!-- Footer -->
    <v-footer padless>
      <v-col class="text-center py-3 white--text">
        &copy; {{ new Date().getFullYear() }} MultiCare Health Pharmacy Sdn Bhd. All rights reserved.
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { images } from '@/config/images';

export default {
  name: "App",
  data() {
    return {
      logoUrl: images.logo
    };
  }
};
</script>

<style scoped>
.v-app-bar {
  border-bottom: none !important;
  box-shadow: none !important;
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  justify-content: flex-start;
  padding-left: 0;
}

.mobile-container {
  max-width: 100% !important;
  padding-left: 0 !important;
  margin-left: 0 !important;
}

.logo-image {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}

/* Logo fixes for all screen sizes */
.logo-link {
  justify-content: flex-start;
  padding-left: 0;
  margin-left: 0;
}

.v-col.cols-2,
.logo-col {
  padding-left: 0;
  margin-left: 0;
}

.mobile-container {
  padding-left: 0 !important;
  margin-left: 0 !important;
}

.v-app-bar .v-container {
  padding-left: 0 !important;
  margin-left: 0 !important;
}

/* Mobile-specific logo fixes */
@media (max-width: 600px) {
  .logo-image {
    max-width: 120px;
    height: 40px !important;
  }
}

/* Large screen logo fixes */
@media (min-width: 960px) {
  .logo-image {
    max-width: 150px;
    height: 50px !important;
  }
  
  .logo-col {
    padding-left: 0 !important;
    margin-left: 0 !important;
  }
}
</style>

<style>
html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  font-family: 'Outfit', 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
}

html {
  overscroll-behavior: none;
}

body {
  background-image: url('assets/vote.png') !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  background-attachment: fixed !important;
  background-size: cover !important;
  min-height: 100vh;
  min-height: 100dvh;
  overscroll-behavior: none;
  overflow-x: hidden;
}

.v-application {
  background: transparent !important;
  overflow-x: hidden;
  min-height: 100vh;
  min-height: 100dvh;
}

.v-main {
  background: transparent !important;
  overflow-x: hidden;
  padding-bottom: 20px;
}

.v-footer {
  position: relative;
  margin-top: 20px;
  background: rgba(13, 18, 29, 0.75) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-top: 1px solid rgba(0, 212, 255, 0.15) !important;
  box-shadow: 0 -4px 30px rgba(0, 0, 0, 0.4) !important;
}

/* Mobile-specific fixes */
@media (max-width: 959px) {
  html, body {
    overscroll-behavior: none;
    overflow-x: hidden;
    min-height: 100dvh;
    background-image: url('assets/voting.png') !important;
    background-repeat: no-repeat !important;
    background-position: center center !important;
    background-attachment: fixed !important;
    background-size: cover !important;
  }
  
  .v-application {
    overscroll-behavior: none;
    min-height: 100dvh;
  }
  
  .v-main {
    padding-bottom: 40px;
  }
  
  .v-footer {
    margin-top: 40px;
  }
}
</style>
